export default {
  label: {
    time: '根据时间搜索',
    orderNo: '根据订单号搜索',
    systemOrderNo: '订单号',
    context: '上下文',
    createTime: '创建时间',
    id: '主键ID',
    message: '说明',
    params: '请求参数',
    request: '请求路径或url',
    response: '响应结果',
    step: '步骤',
    timeline: '耗时',
    callback: '回调地址',
    callbackParams: '回调参数'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/transactionRecord.js